import { message, Modal } from "antd";
import { useTranslation } from "react-i18next";
import {
    useAddReservoirHistoryListMutation,
    useDeleteReservoirHistoryMutation,
    useEditReservoirHistoryMutation,
    useGenerateReportReservoirHistoryMutation
} from "../../../redux/api/reservoirHistory/reservoirHistoryApi";
import { EntReservoirGroupByHistory } from "../../../models/reservoirGroupByHistory";
import { EntReportReservoirHistory } from "../../../models/utils/reportReservoirHistory";
import dayjs from "dayjs";
import { getCookie } from "typescript-cookie";



const useReservoirsHistory = (modal: any, refresh?: () => void) => {
    const { t } = useTranslation()
    const { confirm } = modal;
    const [addReservoirHistory] = useAddReservoirHistoryListMutation();
    const [deleteReservoirHistory] = useDeleteReservoirHistoryMutation();
    const [editReservoirHistory] = useEditReservoirHistoryMutation();
    const [generateReportReservoirHistory] = useGenerateReportReservoirHistoryMutation();

    async function onAddReservoirHistory(newReservoirHistory: EntReservoirGroupByHistory): Promise<boolean> {
        try {
            let status: boolean = false;
            await addReservoirHistory(newReservoirHistory).then((response: any) => {
                if (response.error) {
                    const isKyrgyz = getCookie('i18next') === 'ky';
                    const lang = isKyrgyz ? 'kg' : 'ru';
                    const res = response.error.data?.res;
                    const errorMessages = Array.isArray(res)
                        ? res.map((error: any) => error[lang] || error.ru).join('\n')
                        : response.error.data?.msg || t('unknownError'); 
                    throw new Error(errorMessages);
                }
                if (response.data.success) {
                    status = true;
                    message.success(t('msg.successAdd'));
                    if (refresh) refresh();
                }
            }).catch((error: any) => {
                modal.error({ title: t('msg.error'), content: String(error.message) });

            });
            return status;
        } catch (error: any) {
            modal.error({ title: t('msg.error'), content: String(error.message) });
            return false;
        }
    }


    async function onDeleteReservoirHistory(reservoirHistory: EntReservoirGroupByHistory) {
        try {
            let status: boolean = false;
            confirm({
                centered: true,
                title: t('msg.confirmDeleteText'),
                okText: t('general.yes'),
                cancelText: t('general.no'),
                onOk() {
                    deleteReservoirHistory(reservoirHistory.id as number).then((response: any) => {
                        if (response.error) {
                            const isKyrgyz = getCookie('i18next') === 'ky';
                            const lang = isKyrgyz ? 'kg' : 'ru';
                            const res = response.error.data?.res;
                            const errorMessages = Array.isArray(res)
                                ? res.map((error: any) => error[lang] || error.ru).join('\n')
                                : response.error.data?.msg || t('unknownError'); 
                            throw new Error(errorMessages);
                        }
                        if (response.data.success) {
                            status = true;
                            Modal.success({ title: t('msg.successDelete') });
                            if (refresh) refresh();
                        }
                    }).catch((error: any) => {
                        Modal.error({ title: t('msg.error'), content: String(error.message) });

                    });
                }
            })
            return status
        } catch (error: any) {
            Modal.error({ title: t("msg.error"), content: String(error.message) });
            return false;
        }
    };
    async function onEditReservoirHistory(editedReservoirHistory: EntReservoirGroupByHistory): Promise<boolean> {
        try {
            let status: boolean = false;
            await editReservoirHistory(editedReservoirHistory).then((response: any) => {

                  if (response.error) {
                                              const isKyrgyz = getCookie('i18next') === 'ky';
                                              const lang = isKyrgyz ? 'kg' : 'ru';
                                              const res = response.error.data?.res;
                                              const errorMessages = Array.isArray(res)
                                                  ? res.map((error: any) => error[lang] || error.ru).join('\n')
                                                  : response.error.data?.msg || t('unknownError'); 
                                              throw new Error(errorMessages);
                                          }
                if (response.data.success) {
                    status = true;
                    Modal.success({ title: t('msg.successEdited') });
                    if (refresh) refresh();
                }
            }).catch((error: any) => {
                Modal.error({ title: t('msg.error'), content: String(error.message) });
            });
            return status;
        } catch (error: any) {
            Modal.error({ title: t("msg.error"), content: String(error.message) });
            return false;
        }
    };

    async function onGenerateReservoirReport(newReservoirReport: EntReportReservoirHistory): Promise<boolean> {
        try {
            const response: Blob = await generateReportReservoirHistory(newReservoirReport).unwrap();
            const url = window.URL.createObjectURL(new Blob([response]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Reservoir_Report_${dayjs().format('YYYY-MM-DD')}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            message.success(t('Выгрузка завершена'));
            if (refresh) refresh();
            return true;
        } catch (error: any) {
            modal.error({ title: t('msg.error'), content: String(error.message) });
            return false;
        }
    }

    return { onAddReservoirHistory, onDeleteReservoirHistory, onEditReservoirHistory, onGenerateReservoirReport }

}
export { useReservoirsHistory };

